// Centralized site config — change here to update everywhere
export const SITE = {
  name: "Pompes Funèbres Lumière des Nations",
  shortName: "Lumière des Nations",
  tagline: "À vos côtés dans les moments les plus difficiles.",
  address: "14 rue du Ball, 66540 Baho",
  city: "Baho",
  zip: "66540",
  phone: "06 24 29 91 00",
  phoneTel: "+33624299100",
  phoneHref: "tel:+33624299100",
  email: "josephfunebres@gmail.com",
  availability: "Disponibles 7j/7 — 24h/24",
  priceFrom: "1 997 €",
  badge: "Entreprise indépendante & familiale",
};

export const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Nos services" },
  { to: "/organisation", label: "Organisation d'obsèques" },
  { to: "/marbrerie", label: "Marbrerie & Ornements" },
  { to: "/prevoyance", label: "Prévoyance" },
  { to: "/avis", label: "Avis" },
  { to: "/qui-sommes-nous", label: "Qui sommes-nous" },
  { to: "/contact", label: "Contact" },
];

export const IMAGES = {
  heroCandle: "https://images.unsplash.com/photo-1759606881509-5816fd944c37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHx3aGl0ZSUyMGNhbmRsZSUyMHNvZnQlMjBsaWdodHxlbnwwfHx8fDE3Nzc1NDg2NDZ8MA&ixlib=rb-4.1.0&q=85",
  hands: "https://images.unsplash.com/photo-1773234005378-ceebf3c877b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxob2xkaW5nJTIwaGFuZHMlMjBjb21mb3J0JTIwYmxhY2slMjBhbmQlMjB3aGl0ZXxlbnwwfHx8fDE3Nzc1NDg2NDZ8MA&ixlib=rb-4.1.0&q=85",
  lily: "https://images.unsplash.com/photo-1749748757099-13957c024ad1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHx3aGl0ZSUyMGxpbHklMjBmbG93ZXJ8ZW58MHx8fHwxNzc3NTQ4NjQ2fDA&ixlib=rb-4.1.0&q=85",
  sky: "https://images.unsplash.com/photo-1751578002052-44ee83e73970?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxjYWxtJTIwY2xvdWRzJTIwYmxhY2slMjBhbmQlMjB3aGl0ZXxlbnwwfHx8fDE3Nzc1NDg2NDZ8MA&ixlib=rb-4.1.0&q=85",
};

export const TESTIMONIALS = [
  {
    name: "Famille Martin",
    city: "Perpignan",
    rating: 5,
    text: "Un accompagnement d'une grande humanité. À chaque étape, nous nous sommes sentis écoutés et respectés. Merci infiniment.",
  },
  {
    name: "Claire D.",
    city: "Baho",
    rating: 5,
    text: "Disponibles à toute heure, d'une douceur et d'un professionnalisme remarquables. Tout a été pris en charge avec dignité.",
  },
  {
    name: "Famille Garcia",
    city: "Rivesaltes",
    rating: 5,
    text: "Un soutien précieux dans les démarches administratives. Tarifs clairs, aucune mauvaise surprise. Nous recommandons sans réserve.",
  },
  {
    name: "Jean P.",
    city: "Saint-Estève",
    rating: 5,
    text: "Une équipe à l'écoute, respectueuse et disponible. La cérémonie a été organisée avec une finesse rare. Merci pour tout.",
  },
];
